import React from 'react'
import Tr from 'translations/Translations';
import IconButton from './IconButton';
import AddIcon from '@material-ui/icons/AddBoxOutlined'

function IconAddButton({
	tooltip = Tr('add'),
	...props
}) {
	return <IconButton
		tooltip={tooltip}
		Icon={AddIcon}
		{...props}
	/>
}

export default IconAddButton;